import React from 'react';
import Depot from '../../_shared/depot';
import clsx from 'clsx';
import * as styles from './style.module.css';
export const ButtonSizes = ['small', 'large'];
export const IconSizes = [24, 32];
const IconButtonWithoutRef = ({ icon: Icon, size = 'large', contained = false, iconSize, disabled = false, className, onClick, ...commonProps }) => {
    // force small icons to use 24px for repos that are JS
    let iconSizeToRender = iconSize;
    if (size === 'small')
        iconSizeToRender = 24;
    const buttonClasses = clsx(styles.root, styles[size], contained && styles.contained, className);
    // ensure the button is focused only on keyboard focus and not on click
    const handleMouseDown = (e) => e.preventDefault();
    return Depot.createElement('button', {
        className: buttonClasses,
        onClick: (e) => {
            if (onClick && !disabled) {
                onClick(e);
            }
        },
        ['aria-disabled']: disabled,
        onMouseDown: handleMouseDown,
        ...commonProps,
    }, React.createElement(Icon, { size: iconSizeToRender }));
};
const IconButton = Depot.withRef(IconButtonWithoutRef);
IconButton.displayName = 'IconButton';
export default IconButton;
//# sourceMappingURL=index.js.map